import React, { useEffect } from "react";
import "./LogoInfo.css";
import { BASE_URL } from "../../constants";
import { useUserStore } from "../../store/useUserStore";

const LogoInfo = () => {
  const { user, imageUrl, isReady, loadUser } = useUserStore();
  const token = localStorage.getItem("authToken") || localStorage.getItem("teacher_authToken");

  useEffect(() => {
    if (!user && token) loadUser();
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div className="logo-devsys">
        <img
          src={`${BASE_URL}/files/download/raw/developiaSimpleLogo.png`}
          alt="logo"
        />
      </div>

      {!isReady ? (
        <div className="profile-info">
          <div style={{
            width: 36, height: 36, borderRadius: "50%", flexShrink: 0,
            background: "var(--color-border)",
            animation: "pulse 1.5s ease-in-out infinite",
          }} />
          <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 5 }}>
            <div style={{ height: 11, borderRadius: 4, background: "var(--color-border)", animation: "pulse 1.5s ease-in-out infinite", width: "75%" }} />
            <div style={{ height: 16, borderRadius: 10, background: "var(--color-border)", animation: "pulse 1.5s ease-in-out infinite", width: "45%" }} />
          </div>
        </div>
      ) : (
        <div className="profile-info">
          <div className="profil-img">
            <img
              src={imageUrl}
              alt="profil-img"
              key={imageUrl}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://upload.wikimedia.org/wikipedia/commons/9/99/Sample_User_Icon.png";
              }}
            />
          </div>
          <div className="name-status">
            <h5 className="full-name">
              <span className="name">{user.name}</span>
              <span className="surname"> {user.surname}</span>
            </h5>
            <span className="status">
              {user.userType === "teacher" ? "Müəllim" : user.userType === "student" ? "Tələbə" : user.userType}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default LogoInfo;
